var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29254 4.29253C6.26409 2.32101 8.99032 1.1 12 1.1C15.0097 1.1 17.7359 2.32101 19.7075 4.29253L19.0711 4.92893L19.7075 4.29254C21.679 6.26408 22.9 8.99031 22.9 12C22.9 15.0097 21.679 17.7359 19.7075 19.7074C17.7359 21.679 15.0097 22.9 12 22.9C8.99032 22.9 6.26409 21.679 4.29254 19.7074L4.92894 19.071L4.29254 19.7074C2.32102 17.7359 1.10001 15.0097 1.10001 12C1.10001 8.99032 2.32102 6.26409 4.29253 4.29254L4.29254 4.29253ZM12 2.9C9.48689 2.9 7.21312 3.91757 5.56533 5.56533C3.91756 7.21312 2.90001 9.48688 2.90001 12C2.90001 14.5131 3.91757 16.7869 5.56533 18.4347C7.21312 20.0824 9.48689 21.1 12 21.1C14.5131 21.1 16.7869 20.0824 18.4347 18.4347C20.0824 16.7869 21.1 14.5131 21.1 12C21.1 9.48688 20.0824 7.21311 18.4347 5.56533C16.7869 3.91757 14.5131 2.9 12 2.9ZM12 18.5C12.6903 18.5 13.25 17.9403 13.25 17.25C13.25 16.5597 12.6903 16 12 16C11.3097 16 10.75 16.5597 10.75 17.25C10.75 17.9403 11.3097 18.5 12 18.5ZM12.9 14.9V5.1H11.1V14.9H12.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dda12f64fc95082690b5884f23fed3ec.svg";
export { ForwardRef as ReactComponent };